<app-list-page
  [headline]="
    (lastResult.totalNumberResultsets === 1 ? 'customer.size.singular' : 'customer.size.plural')
      | translate: { customers: lastResult.totalNumberResultsets || 0 }
  "
  (downloadList)="downloadTheList()"
  [detailsLoaded]="customerId && items.size > 0 ? true : false">
  <hoc-filter-block
    data-testid="customer-filter-block"
    filter
    (changed)="filterBlockChanged($event)"
    [filters]="filtersForBlock"
    [isAdmin]="isAdmin"
    [textSearch]="searchForName"
    defaultSorting="asc" />
  <hoc-grouped-list
    data-testid="customer-list"
    list
    [loading]="loading"
    [items]="items"
    [groupLetters]="groupLetters"
    [loadingBlock]="loadingBlock"
    [itemBlock]="itemBlock"
    [groupBlock]="groupBlock"
    [footerBlock]="footerBlock"
    [emptyItemsBlock]="emptyItemsBlock"
    (scrolledToEnd)="scrolledToEnd()">
  </hoc-grouped-list>
  <app-customer-details
    details
    [customer]="selectedCustomer"
    [isAdmin]="isAdmin"
    (closeClicked)="closeDrawer()"></app-customer-details>
</app-list-page>

<ng-template #emptyItemsBlock>
  <app-empty-list-page (backButtonClicked)="handleEmptyList()"></app-empty-list-page>
</ng-template>

<ng-template #groupBlock let-letter>
  <h3 class="list-title-text">{{ letter }}</h3>
</ng-template>

<ng-template #loadingBlock>
  <app-list-placeholder [hasTitle]="true" [columnCount]="4" />
</ng-template>

<ng-template #itemBlock let-item>
  <app-list-item [data]="getCustomerListItem(item)" (onClicked)="clickedOnCustomer(item)" />
</ng-template>

<ng-template #footerBlock>
  <div #footerContainer class="px-3 py-4">
    @if (loadMode === 'paged' && items.size > 0) {
      <gx-pagination
        data-testid="customer-list-pagination"
        [data]="pagination"
        (newPage)="gotoPage($event)"
        [availablePageSizes]="config.pageSizes"
        [lengthBeginSegment]="4"
        [lengthEndSegment]="4"
        [currentPageSize]="filter.pageSize"
        (newPageSize)="newPageSize($event)" />
    }

    @if (loadMode === 'infinite' && canLoadMore) {
      <app-list-placeholder [columnCount]="4" />
    }
  </div>
</ng-template>
